import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/svg/illustrations/team-created.svg?data'


const _hoisted_1 = { class: "invite-accepted-successful" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "An illustration of a group of people sitting by a desk"
}, null, -1)
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Continue")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    id: "invite-accepted-successful",
    title: _ctx.inviteModalTitle
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_AppButton, { onClick: _ctx.closeModal }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("p", {
          class: "dropdown-title",
          innerHTML: _ctx.inviteModalMessage
        }, null, 8, _hoisted_3)
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}